import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { Order } from '../../../app/data/models/orders/order';
import api from '../../../app/api/api';
import CurrentPageItem from '../../../app/data/models/common/currentPageItem';

export interface OrdersState {
  status: string;
  orders: Order[];
  nextPageId?: string;
}

const initialState: OrdersState = {
  status: 'idle',
  orders: [],
  nextPageId: undefined,
};

export const getOrdersAsync = createAsyncThunk<
  CurrentPageItem<Order>,
  { restaurantId: string; nextPageId?: string }
>('orders/list', async ({ restaurantId, nextPageId }, thunkApi) => {
  try {
    return await api.Order.list(restaurantId, nextPageId);
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return thunkApi.rejectWithValue({ error: error.response?.data });
    }
    return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
  }
});

export const orderListSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrdersAsync.pending, (state) => {
      state.status = 'pendingFetchRestaurantOrdersList';
    });
    builder.addCase(getOrdersAsync.fulfilled, (state, action) => {
      state.orders = action.payload.data;
      state.nextPageId = action.payload.nextPageId;
      state.status = 'idle';
    });
    builder.addCase(getOrdersAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
